import { render, staticRenderFns } from "./AmadeusPackageTourSearch.vue?vue&type=template&id=5b9b9cd3&"
import script from "./AmadeusPackageTourSearch.vue?vue&type=script&lang=js&"
export * from "./AmadeusPackageTourSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports